import { render, staticRenderFns } from "./CustomerSchedule.vue?vue&type=template&id=28c2ac3c&scoped=true&"
import script from "./CustomerSchedule.vue?vue&type=script&lang=js&"
export * from "./CustomerSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSchedule.vue?vue&type=style&index=0&id=28c2ac3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2ac3c",
  null
  
)

export default component.exports